const trackFormSubmission = (formId: string) => {
  if (typeof window !== "undefined" && window._hsq) {
    window._hsq.push(["trackFormSubmission", formId]);
  } else {
    console.warn("HubSpot tracking code is not loaded");
  }
};

export default trackFormSubmission;
